var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export function flattenCategories(categories) {
    var flattenedCategories = {};
    function recursiveFlatten(category, level) {
        flattenedCategories[category.id] = __assign(__assign({}, category), { level: level });
        if (category.categories && category.categories.length > 0) {
            for (var _i = 0, _a = category.categories; _i < _a.length; _i++) {
                var subCategory = _a[_i];
                recursiveFlatten(subCategory, level + 1);
            }
        }
    }
    for (var _i = 0, categories_1 = categories; _i < categories_1.length; _i++) {
        var category = categories_1[_i];
        recursiveFlatten(category, 1);
    }
    return flattenedCategories;
}
